import { colorBg } from 'mt-react-theme-manager';
import { ReactElement, useCallback, useState, ChangeEvent } from 'react';
import { colorFillColor } from 'mt-react-theme-manager';
import { useTranslation } from 'react-i18next';

import { Preset } from '../../../components/Button';
import { TextButton } from '../../../components/TextButton';
import Checkbox from '../../../components/Checkbox';

import './styles.scss';

interface Props {
  onSubmit: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default function FastOnboardFormFooter({
  onSubmit
}: Props): ReactElement {
  const { t } = useTranslation();
  const [acceptTerms, setAcceptTerms] = useState(false);

  const onCheckboxChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setAcceptTerms(e.currentTarget.checked);
  }, []);

  return (
    <div className={`fast-onboard-form-footer ${colorBg('primary', 'base')}`}>
      <div className="footer-content">
        <Checkbox
          className={`onboard-agreed-checkbox ${colorFillColor('primary', 'base')}`}
          name="guest[terms_of_service]"
          checked={acceptTerms}
          onChange={onCheckboxChange}
        >
          {t('FastOnboardForm.footer.jp.agreeCheckbox')}
        </Checkbox>
        <TextButton
          big
          className={`onboard-agreed-button ${colorFillColor('primary')}`}
          preset={Preset.Primary}
          text={t('FastOnboardForm.footer.jp.submitButton')}
          type="submit"
          onPress={onSubmit}
          disabled={!acceptTerms}
        />
      </div>
    </div>
  );
}
